import { Observable } from 'rxjs';

import { ConsumptionData } from '../../http';
import {
  GiftCardModel,
  SessionsModel,
  VoucherBySerialNumberModel,
  VoucherCancellationModel,
  VoucherConsumptionModel,
  VoucherHistoryModel,
  VoucherModel,
} from '../../../models';

export abstract class IVouchersService {
  abstract getVoucher(country: string, numCard: string, skipErrorInterceptor?: boolean): Promise<VoucherModel>;
  abstract getVoucherHistory(country: string, numCard: string): Promise<VoucherHistoryModel>;
  abstract getVoucherSessions(country: string, numCard: string): Promise<SessionsModel>;
  abstract updateLastVoucher(nbTicketRemaining: number): void;
  abstract getLastVoucher(country: string, voucherCode: string, redownload?: boolean): Promise<VoucherModel>;
  abstract consumeVoucher(country: string, numCard: string, data: ConsumptionData): Promise<VoucherConsumptionModel>;
  abstract cancelVoucherOperation(
    country: string,
    numCard: string,
    transactionNumber: number,
    salesChannel: string,
  ): Promise<VoucherCancellationModel>;
  abstract getVoucherBySerialNumber(
    country: string,
    type: string,
    serialNumberStart: number,
    serialNumberEnd?: number,
  ): Promise<VoucherBySerialNumberModel>;
  abstract getVoucherBySerialNumberWithPagination(
    country: string,
    type: string,
    serialNumberStart: number,
    serialNumberEnd: number,
    pageIndex: number,
  ): Observable<{ data: VoucherModel[]; total: number; hasMore: boolean }>;
  abstract getAllVouchersForExport(
    country: string,
    type: string,
    serialNumberStart: number,
    serialNumberEnd: number,
  ): Observable<VoucherModel[]>;
  abstract getGiftCard(country: string, numCard: string, pin: number): Promise<GiftCardModel>;
  abstract getLastGiftCard(code: string): GiftCardModel | null;
  abstract resetCache(): void;
}
